module.exports = __webpack_public_path__ + "img/15.01f83100.jpg";